import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import './alert.css';

class Alert extends Component {
  static propTypes = {
    type: PropTypes.oneOf(['info', 'danger', 'success']).isRequired,
    message: PropTypes.string.isRequired,
  }

  render() {
    const { message, type } = this.props;
    return (
      <div className={classNames('alert', `alert-${type}`)}>
        { message }
      </div>
    )
  }
}

export default Alert;



// WEBPACK FOOTER //
// ./src/components/Alert/Alert.js